import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("section", { class: "p-about__sec" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"color":"red"} }, [
    /*#__PURE__*/_createTextVNode("集英社ID（登録・ログイン）に関するお問い合わせフォームです。"),
    /*#__PURE__*/_createElementVNode("br", { class: "u-br-pc" }),
    /*#__PURE__*/_createTextVNode("雑誌・サービスに関するお問い合わせ（注文、商品、イベント、記事内容等）は、各サービスのカスタマーサポートまでお問い合わせください。")
  ])
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "p-about__ttl--primary c-ttl--primary" }, "お問い合わせ", -1)
const _hoisted_3 = { class: "p-about__sec" }
const _hoisted_4 = { class: "p-contact__field-container" }
const _hoisted_5 = { class: "p-fields" }
const _hoisted_6 = { class: "c-field" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  class: "c-field__label",
  for: "lastName"
}, [
  /*#__PURE__*/_createTextVNode("お名前"),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "必須")
], -1)
const _hoisted_8 = { class: "c-field__body" }
const _hoisted_9 = { class: "c-field__input has-horizontal-item" }
const _hoisted_10 = { class: "c-field" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  class: "c-field__label",
  for: "lastKana"
}, "ふりがな", -1)
const _hoisted_12 = { class: "c-field__body" }
const _hoisted_13 = { class: "c-field__input has-horizontal-item" }
const _hoisted_14 = { class: "c-field" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  class: "c-field__label",
  for: "email"
}, [
  /*#__PURE__*/_createTextVNode("メールアドレス"),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "必須")
], -1)
const _hoisted_16 = { class: "c-field__body" }
const _hoisted_17 = { class: "c-field__input" }
const _hoisted_18 = { class: "c-field" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", {
  class: "c-field__label",
  for: "service"
}, [
  /*#__PURE__*/_createTextVNode("ご利用サービス"),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "必須")
], -1)
const _hoisted_20 = { class: "c-field__body" }
const _hoisted_21 = { class: "c-field__select" }
const _hoisted_22 = ["value"]
const _hoisted_23 = { class: "c-field" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", {
  class: "c-field__label",
  for: "subject"
}, [
  /*#__PURE__*/_createTextVNode("お問い合わせ項目"),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "必須")
], -1)
const _hoisted_25 = { class: "c-field__body" }
const _hoisted_26 = { class: "c-field__select" }
const _hoisted_27 = ["value"]
const _hoisted_28 = { class: "c-field" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", {
  class: "c-field__label",
  for: "detail"
}, [
  /*#__PURE__*/_createTextVNode("お問い合わせ内容"),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "必須")
], -1)
const _hoisted_30 = { class: "c-field__body" }
const _hoisted_31 = { class: "c-field__textarea" }
const _hoisted_32 = { class: "c-field has-submit has-mt" }
const _hoisted_33 = ["disabled"]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", null, "入力内容を確認する", -1)
const _hoisted_35 = [
  _hoisted_34
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _createVNode(_component_Form, {
      onSubmit: _ctx.confirm,
      "validation-schema": _ctx.schema
    }, {
      default: _withCtx(({ errors, meta }) => [
        _createElementVNode("section", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("fieldset", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_Field, {
                      type: "text",
                      id: "lastName",
                      name: "lastName",
                      modelValue: _ctx.contactFormItems.lastName,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.contactFormItems.lastName) = $event)),
                      placeholder: "姓",
                      autocomplete: "family-name",
                      required: ""
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_Field, {
                      type: "text",
                      id: "firstName",
                      name: "firstName",
                      modelValue: _ctx.contactFormItems.firstName,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.contactFormItems.firstName) = $event)),
                      placeholder: "名",
                      autocomplete: "given-name",
                      required: ""
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ]),
              _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.lastName), 513), [
                [_vShow, errors.lastName]
              ]),
              _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.firstName), 513), [
                [_vShow, errors.firstName]
              ]),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_Field, {
                      type: "text",
                      id: "lastKana",
                      name: "lastKana",
                      modelValue: _ctx.contactFormItems.lastKana,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.contactFormItems.lastKana) = $event)),
                      placeholder: "せい"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_Field, {
                      type: "text",
                      id: "firstKana",
                      name: "firstKana",
                      modelValue: _ctx.contactFormItems.firstKana,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.contactFormItems.firstKana) = $event)),
                      placeholder: "めい"
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ]),
              _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.lastKana), 513), [
                [_vShow, errors.lastKana]
              ]),
              _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.firstKana), 513), [
                [_vShow, errors.firstKana]
              ]),
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_Field, {
                      type: "text",
                      id: "email",
                      name: "email",
                      modelValue: _ctx.contactFormItems.email,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.contactFormItems.email) = $event)),
                      placeholder: "メールアドレス",
                      autocomplete: "email",
                      required: ""
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ]),
              _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.email), 513), [
                [_vShow, errors.email]
              ]),
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_Field, {
                      as: "select",
                      id: "service",
                      name: "service",
                      modelValue: _ctx.contactFormItems.service,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.contactFormItems.service) = $event)),
                      required: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.serviceSelection, (sel, idx) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: idx,
                            value: sel.value
                          }, _toDisplayString(sel.text), 9, _hoisted_22))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ])
              ]),
              _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.service), 513), [
                [_vShow, errors.service]
              ]),
              _createElementVNode("div", _hoisted_23, [
                _hoisted_24,
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createVNode(_component_Field, {
                      as: "select",
                      id: "subject",
                      name: "subject",
                      modelValue: _ctx.contactFormItems.subject,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.contactFormItems.subject) = $event)),
                      required: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subjectSelection, (sel, idx) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: idx,
                            value: sel.value
                          }, _toDisplayString(sel.text), 9, _hoisted_27))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ])
              ]),
              _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.subject), 513), [
                [_vShow, errors.subject]
              ]),
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createVNode(_component_Field, {
                      as: "textarea",
                      id: "detail",
                      name: "detail",
                      modelValue: _ctx.contactFormItems.detail,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.contactFormItems.detail) = $event)),
                      class: "textarea",
                      cols: "",
                      rows: "5",
                      spellcheck: "false",
                      placeholder: "こちらに詳細を入力してください。",
                      required: ""
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ]),
              _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.detail), 513), [
                [_vShow, errors.detail]
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("button", {
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args))),
                  class: "c-btn is-submit",
                  disabled: !meta.valid
                }, _hoisted_35, 8, _hoisted_33)
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["onSubmit", "validation-schema"])
  ], 64))
}